import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submitButton', 'arrow', 'spinner', 'input'];

  connect() {
    this.updateSubmitButton();

    // Listen to all radio button changes within the form
    this.element.addEventListener('change', (e) => {
      if (e.target.type === 'radio') {
        this.updateSubmitButton();
        this.handleRadioChange(e);
      }
    });
  }

  handleRadioChange(event) {
    const selectedRadio = event.target;
    
    // Check if this radio button has an associated adjustable value
    const hasAdjustableValue = this.hasAdjustableValue(selectedRadio);
    
    // If no adjustable value, auto-submit after a short delay
    if (!hasAdjustableValue) {
      // Small delay to ensure the radio button is properly selected
      setTimeout(() => {
        this.autoSubmit();
      }, 100);
    }
  }

  hasAdjustableValue(radioElement) {
    // Check if the radio button's parent label contains a number field
    const parentLabel = radioElement.closest('label');
    if (parentLabel) {
      const numberField = parentLabel.querySelector('[data-radio-button-target="numberField"]');
      return numberField !== null;
    }
    
    return false;
  }

  autoSubmit() {
    // Show loading state
    this.handleSubmit();
    
    if (typeof this.element.requestSubmit === 'function') {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }

  updateSubmitButton() {
    // Check if we're in direct mode (no radio buttons, just hidden input)
    const isDirectMode = this.element.dataset.questionFormDirect === 'true';

    if (isDirectMode) {
      // In direct mode, button is always enabled with full color
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.style.backgroundColor = '#EF5844';
      return;
    }

    // Regular radio button logic for non-direct mode
    const anyRadioSelected = this.element.querySelector(
      'input[type="radio"]:checked'
    );
    this.submitButtonTarget.disabled = !anyRadioSelected;
    this.submitButtonTarget.style.backgroundColor = anyRadioSelected
      ? '#EF5844'
      : '#F7ABA1';
  }

  handleSubmit() {
    this.arrowTarget.classList.add('hidden');
    this.spinnerTarget.classList.remove('hidden');
  }
}